import { render, staticRenderFns } from "./BrandedCheckbox.vue?vue&type=template&id=0daad532&"
import script from "./BrandedCheckbox.vue?vue&type=script&lang=js&"
export * from "./BrandedCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BrandedCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports